// extracted by mini-css-extract-plugin
export default {"supplierTextLink":"y3INBjABVZGPoH8NCq_s__supplierTextLink___","lots":"xV1csgD6hvjIjl6c4aXQ__lots___","lotName":"GuYeYH0dKJfTVYZ_BAuV__lotName___"};